var Coupon = {
    deleteCoupon: function(element){
        var aim = $(element).data('aim');
        $(aim).val("");
    }
};